import { Box } from '@nimbus-ds/components';
import { Responsive } from 'commons/components';
import {
  VisibleVariantInfoDesktop,
  VisibleVariantInfoDesktopProps,
  VisibleVariantInfoMobile,
  VisibleVariantInfoMobileProps,
} from './components';

import './VariantInfo.scss';

type VariantInfoProps = VisibleVariantInfoDesktopProps &
  VisibleVariantInfoMobileProps;

function VariantInfo({
  variant,
  locations,
  index,
  onChange,
  onClickImage,
  onClickVariant,
  onOpenVariantStock,
}: VariantInfoProps) {
  return (
    <Box data-style="stratus--variant-info">
      <Responsive
        mobile={
          <VisibleVariantInfoMobile
            variant={variant}
            locations={locations}
            index={index}
            onChange={onChange}
            onClickImage={onClickImage}
            onClickVariant={onClickVariant}
            onOpenVariantStock={onOpenVariantStock}
          />
        }
        desktop={
          <VisibleVariantInfoDesktop
            variant={variant}
            index={index}
            onClickImage={onClickImage}
            onClickVariant={onClickVariant}
            onChange={onChange}
          />
        }
      />
    </Box>
  );
}

export default VariantInfo;
